<!--
frontend-author:udayasankar,
backend-author: ,
page-name :Sales by Customer.vue,
page-description :Sales by Customer for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Customer-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-4"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,1)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>

          <b-dropdown-item v-b-modal.InvoiceReport>General</b-dropdown-item>
          <b-dropdown-item v-b-modal.custom_index>Show/hide columns</b-dropdown-item>

          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export Invoice Details
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4>Invoice details</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <!-- <GlobalLoader v-show="loader"/> -->
          <div class="table-responsive" id="reportScrollCol">
            <!--  Invoice Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  Invoice Table head-->
              <thead class="tbl-col">
                <tr>
                  <th style="width:110px !important">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'inv_status_name'} }"
                      class="text-dark text-decoration-none"
                    >
                      Status
                      <small class="text-muted" v-if="label == 'inv_status_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'created_date'} }"
                      class="text-dark text-decoration-none"
                    >
                      Date
                      <small class="text-muted" v-if="label == 'created_date'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'due_date'} }"
                      class="text-dark text-decoration-none"
                    >
                      Due Date
                      <small class="text-muted" v-if="label == 'due_date'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:120px !important">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'inv_no'} }"
                      class="text-dark text-decoration-none"
                    >
                      Inv
                      <small class="text-muted" v-if="label == 'inv_no'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:120px !important">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'order_no'} }"
                      class="text-dark text-decoration-none"
                    >
                      Order No
                      <small class="text-muted" v-if="label == 'order_no'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:180px !important">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'cus_name'} }"
                      class="text-dark text-decoration-none"
                    >
                      Customer
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'grand_total'} }"
                      class="text-dark text-decoration-none"
                    >
                      Total(BCY)
                      <small class="text-muted" v-if="label == 'grand_total'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:'due_amount'} }"
                      class="text-dark text-decoration-none"
                    >
                      Balance(BCY)
                      <small class="text-muted" v-if="label == 'due_amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th
                    v-for="(column) in reported_columns"
                    v-if="column.checked == true"
                    :key="column.id"
                    :style="{'width':column.colWidth+'px !important'}"
                    :class="{'text-right':column.align=='right'}"
                  >
                    <template
                      v-if="column.field=='sales_person_name'||column.field=='adjusted_amount'||column.field=='export_adjusted_amount'||column.field=='total_without_tax'||column.field=='export_total_without_tax'||column.field=='paid_amount'||column.field=='export_paid_amount'"
                    >
                      <b-row v-b-tooltip.top :title="column.title">
                        <b-col sm="10" class="pr-0">
                          <router-link
                            :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:column.field} }"
                            class="text-dark text-decoration-none"
                          >
                            <span class="text">{{ column.title }}</span>
                          </router-link>
                        </b-col>
                        <b-col sm="2" class="pl-0">
                          <small class="text-muted" v-if="label == column.field">
                            <i
                              :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                              style="font-weight:thinner;"
                            ></i>
                          </small>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>
                      <span :style="{'width':column.colWidth+'px !important'}">
                        <router-link
                          :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,group_by:$route.query.group_by,select_columns:$route.query.select_columns,sort:sort == 'asc' ? 'desc' : 'asc',label:column.field} }"
                          class="text-dark text-decoration-none"
                        >
                          {{ column.title }}
                          <small class="text-muted" v-if="label == column.field">
                            <i
                              :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                              style="font-weight:thinner;"
                            ></i>
                          </small>
                        </router-link>
                      </span>
                    </template>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->

              <template v-if="lists.length == 0">
                <tbody>
                  <tr>
                    <td colspan="9" class="text-center">No data to display</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </tbody>
              </template>
              <template
                v-else-if="typeof $route.query.group_by != 'undefined' && $route.query.group_by != 0"
              >
                <tbody
                  v-for="group in group_total_amount"
                  :key="group.id"
                  v-if="getPresentValue(lists,$route.query.group_by,group[$route.query.group_by]) == true"
                >
                  <tr>
                    <td
                      colspan="6"
                      class="fw-semi-bold"
                    >{{ $route.query.group_by == 'created_date' ? getDateFormat(group.group_by) : $route.query.group_by == 'due_date' ? getDateFormat(group.group_by): group.group_by }}</td>
                    <td
                      class="text-right fw-semi-bold"
                    >{{ orgCurrencySymbol+" "+Number(group.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right fw-semi-bold"
                    >{{ orgCurrencySymbol+" "+Number(group.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                  <tr
                    v-for="item in lists"
                    :key="item.id"
                    v-if="item[$route.query.group_by] == group[$route.query.group_by]"
                  >
                    <td>{{ item.inv_status_name }}</td>
                    <td>{{ getDateFormat(item.created_date) }}</td>
                    <td>{{ getDateFormat(item.due_date) }}</td>
                    <td>{{ item.inv_no }}</td>
                    <td>{{ item.order_no }}</td>
                    <td style="width:180px !important">
                      <span class="text">{{ item.cus_name }}</span>
                    </td>
                    <td
                      class="text-right"
                    >{{orgCurrencySymbol+" "+Number(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                    >{{ orgCurrencySymbol+" "+Number(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      :class="{'text-right':column.align=='right'}"
                      v-for="(column) in reported_columns"
                      v-if="column.checked == true"
                      :key="column.id"
                      :style="{'width':column.colWidth+'px !important'}"
                    >
                      <span
                        v-if="column.field=='place_of_supply'"
                      >{{ getDetails($AppDetails.state_details,item.place_of_supply,'state_name')}}</span>
                      <span
                        v-if="column.field=='cus_currency'"
                      >{{getDetails($AppDetails.currency_details,item.cus_currency,'currency_name')}}</span>

                      <span
                        v-if="column.field=='adjusted_amount'"
                      >{{ orgCurrencySymbol+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                      <span v-else-if="column.field=='export_due_amount'">
                        {{getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+ Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span v-else-if="column.field=='export_grand_total'">
                        {{getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+ Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span v-else-if="column.field=='export_adjusted_amount'">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span v-else-if="column.field=='export_inv_tax'">
                        {{getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+ Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span v-else-if="column.field=='export_total_without_tax'">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>

                      <span
                        v-else-if="column.field=='inv_tax'"
                      >{{ orgCurrencySymbol+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                      <span
                        v-else-if="column.field=='total_without_tax'"
                      >{{ orgCurrencySymbol+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                      <span v-else-if="column.field=='export_paid_amount'">
                        {{getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+ " "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>

                      <span
                        v-else-if="column.field=='paid_amount'"
                      >{{ orgCurrencySymbol+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                      <span
                        :class="{'text':column.align=='overflow'}"
                        v-else
                      >{{item[column.field] }}</span>
                    </td>
                  </tr>
                </tbody>
                <tr>
                  <td colspan="6" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>
                  <td
                    class="fw-semi-bold text-right"
                  >{{orgCurrencySymbol+" "+Number(total_amount.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    class="fw-semi-bold text-right"
                  >{{ orgCurrencySymbol+" "+Number(total_amount.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    v-if="reported_columns.length > 0 && show_columns_length > 0"
                    :colspan="parseInt(reported_columns.length) - 0"
                  ></td>
                </tr>
              </template>
              <template v-else>
                <tbody>
                  <tr v-for="item in lists" :key="item.id">
                    <td>{{ item.inv_status_name }}</td>
                    <td>{{ getDateFormat(item.created_date) }}</td>
                    <td>{{ getDateFormat(item.due_date) }}</td>
                    <td v-if="RoutePermission(false,'','invoice','invoice','index')">
                      <router-link
                        class="text-decoration-none"
                        :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id }}"
                      >{{ item.inv_no }}</router-link>
                    </td>
                    <td v-else>{{ item.inv_no }}</td>
                    <td>{{ item.order_no }}</td>
                    <td style="width:180px !important">
                      <span class="text">{{ item.cus_name }}</span>
                    </td>
                    <td
                      class="text-right"
                    >{{ orgCurrencySymbol+" "+Number(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                    >{{ orgCurrencySymbol+" "+Number(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      :class="{'text-right':column.align=='right'}"
                      v-for="(column) in reported_columns"
                      v-if="column.checked == true"
                      :key="column.id"
                      :style="{'width':column.colWidth+'px !important'}"
                    >
                      <span
                        v-if="column.field=='place_of_supply'"
                      >{{ getDetails($AppDetails.state_details,item.place_of_supply,'state_name')}}</span>
                      <span
                        v-else-if="column.field=='cus_currency'"
                      >{{getDetails($AppDetails.currency_details,item.cus_currency,'currency_name')}}</span>

                      <span
                        v-else-if="column.field=='adjusted_amount'"
                      >{{ orgCurrencySymbol+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                      <span
                        v-else-if="column.field=='credit_limit'||column.field=='export_paid_amount'||column.field=='export_total_without_tax'||column.field=='export_inv_tax'||column.field=='export_adjusted_amount'||column.field=='export_due_amount'||column.field=='export_grand_total'"
                      >
                        {{getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+ Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>

                      <span
                        v-else-if="column.field=='total_without_tax'||column.field=='inv_tax'||column.field=='paid_amount'"
                      >{{ orgCurrencySymbol+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                      <span
                        :class="{'text':column.align=='overflow'}"
                        v-else
                      >{{item[column.field] }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </tbody>
              </template>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,select_columns:$route.query.select_columns,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <nav class="float-right">
          <ul class="pagination">
            <li class="page-item">
              <template v-if="page != 1">
                <router-link
                  class="page-link"
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                >
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </router-link>
              </template>
              <template v-else>
                <a class="page-link" href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </template>
            </li>
            <li class="page-item">
              <router-link
                class="page-link"
                :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
              >First</router-link>
            </li>
            <li class="page-item">
              <template v-if="page != 1">
                <router-link
                  class="page-link"
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                >Previous</router-link>
              </template>
              <template v-else>
                <a href="#" class="page-link">Previous</a>
              </template>
            </li>
            <li class="page-item">
              <template v-if="total_count > (page * count)">
                <router-link
                  class="page-link"
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label } }"
                >Next</router-link>
              </template>
              <template v-else>
                <a href="#" class="page-link">Next</a>
              </template>
            </li>
            <li class="page-item">
              <router-link
                class="page-link"
                :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label } }"
              >Last</router-link>
            </li>
            <li class="page-item">
              <template v-if="total_count > (page * count)">
                <router-link
                  class="page-link"
                  :to="{ name : 'InvoiceReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label } }"
                >
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </router-link>
              </template>
              <template v-else>
                <a class="page-link" href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </template>
            </li>
          </ul>
        </nav>
      </b-col>
    </b-row>

    <!--  Model-->
    <!--  Model-->
    <b-modal
      id="InvoiceReport"
      title="Customize Report"
      body-class="bg-white"
      size="lg"
      ref="runreport"
      ok-title="Run Report"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      cancel-variant="light"
      @shown="displayvalue()"
    >
      <!-- Validation for InvoiceReport reports -->
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
              <button type="button" @click="error_show=!error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div v-for="(item,index) in items" :key="index">
                <p
                  class="text-danger"
                  v-if="errors.has('filter_matching['+index+']')"
                >Row {{ index + 1 }} : Please enter the matching type</p>
                <p
                  class="text-danger"
                  v-if="errors.has(item.field+'['+index+']')"
                >Row {{ index + 1 }} : Please enter the customize name</p>
                <p
                  class="text-danger"
                  v-if="errors.has('type['+index+']')"
                >Row {{ index + 1 }} : Please enter customize type</p>
                <p
                  class="text-danger"
                  v-if="errors.has('value['+index+']')"
                >Row {{ index + 1 }} : Please enter customize value</p>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <b-form-group label="Date" label-for="date" :label-cols="2">
                <GlobalDateRangePicker
                  :singleDatePicker="false"
                  v-on:setDateRange="getDateRange($event)"
                  :fromDate="from_date"
                  :toDate="to_date"
                />
                <input type="hidden" name="from_date" v-model.trim="from_date" />
                <input type="hidden" name="to_date" v-model.trim="to_date" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="8" lg="8" md="8" sm="8" xs="8">
              <b-form-group>
                <label>Group By</label>
                <b-form-select class="form-control" v-model.trim="group_by">
                  <option value="0"></option>
                  <option value="created_date">Invoice Date</option>
                  <option value="due_date">Due Date</option>
                  <option value="cus_id">Customer Name</option>
                  <option value="sales_person_id">Sales Person</option>
                  <option value="pjt_id">Project</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Advanced Filters" label-for="adv-filter" :label-cols="5" />
          <b-row v-for="(item,index) in items" :key="index">
            <b-col xl="2" lg="2" md="2" sm="2" xs="2">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.filter_matching"
                  v-validate="'required'"
                  :name="'filter_matching['+index+']'"
                  v-if="index > 0"
                >
                  <option value="and">And</option>
                  <option value="or">Or</option>
                </b-form-select>
                <input
                  type="text"
                  v-else
                  class="form-control"
                  v-model.trim="item.filter_matching"
                  v-validate="'required'"
                  :name="'filter_matching['+index+']'"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.field"
                  v-validate="'required'"
                  @change="item.value = ''"
                  :name="item.field+'['+index+']'"
                >
                  <option value="cus_id">Customer Name</option>
                  <option value="created_date">Invoice Date</option>
                  <option value="due_date">Due Date</option>
                  <option value="inv_no">Invoice No</option>
                  <option value="order_no">Order No</option>
                  <option value="inv_status">Status</option>
                  <option value="grand_total">Total Amount</option>
                  <option value="due_amount">Balance Due</option>
                  <option value="pjt_id">Project Name</option>
                  <option value="sales_person_id">Sales person</option>
                  <option value="inv_tags">Invoice tag</option>
                  <option value="ref_no">Reference no</option>
                  <!-- <option value="buyer_gst_type">Buyer GST Type</option>
                  <option value="buyer_gst_no">Buyer GST No</option>-->
                  <option value="pdt_ids">Product Name</option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.comparator"
                  v-validate="'required'"
                  :name="'type['+index+']'"
                >
                  <option value="1" v-if="item.field != 'inv_tags' && item.field != 'pdt_ids'">Is</option>
                  <option
                    value="2"
                    v-if="item.field != 'inv_tags' && item.field != 'pdt_ids'"
                  >Is not</option>
                  <option
                    value="3"
                    v-if="item.field == 'grand_total' || item.field == 'due_amount' || item.field == 'created_date' || item.field == 'due_date'"
                  >Greater than</option>
                  <option
                    value="4"
                    v-if="item.field == 'grand_total' || item.field == 'due_amount' || item.field == 'created_date' || item.field == 'due_date'"
                  >Less than</option>
                  <option
                    value="5"
                    v-if="item.field == 'inv_no'||item.field=='order_no' || item.field == 'ref_no' || item.field == 'buyer_gst_no'"
                  >Starts with</option>
                  <option
                    value="6"
                    v-if="item.field == 'inv_no'||item.field=='order_no' || item.field == 'ref_no' || item.field == 'buyer_gst_no'"
                  >Ends with</option>
                  <option
                    value="7"
                    v-if="item.field == 'inv_no'||item.field=='order_no' || item.field == 'ref_no' || item.field == 'buyer_gst_no'"
                  >Contains</option>
                  <option
                    value="8"
                    v-if="item.field == 'inv_no'||item.field=='order_no' || item.field == 'ref_no' || item.field == 'buyer_gst_no'"
                  >Does not contains</option>
                  <!-- <option
                    value="9"
                    v-if="item.field == 'created_date' || item.field == 'due_date'"
                  >Between</option>-->
                  <option value="10" v-if="item.field == 'inv_tags' || item.field == 'pdt_ids'">In</option>
                  <option
                    value="11"
                    v-if="item.field == 'inv_tags' || item.field == 'pdt_ids'"
                  >Not In</option>
                  <option
                    value="12"
                    v-if="item.field == 'grand_total' || item.field == 'due_amount' || item.field == 'created_date' || item.field == 'due_date'"
                  >Greater than or equal to</option>
                  <option
                    value="13"
                    v-if="item.field == 'grand_total' || item.field == 'due_amount' || item.field == 'created_date' || item.field == 'due_date'"
                  >Less than or equal to</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5" @click="removecustomer($event,index)">
              <b-form-group>
                <input
                  :type="item.field =='cus_id' || item.field =='pdt_ids' ? 'hidden' : 'text'"
                  class="form-control"
                  v-model.trim="item.value"
                  v-if="item.field =='cus_id' || item.field =='pdt_ids'"
                  v-validate="'required'"
                  :name="'value['+index+']'"
                />
                <vue-bootstrap-typeahead
                  @input="customerlist($event,index)"
                  v-model="item.cus_detail_id"
                  :id="'customer_search_'+index"
                  name="cus_detail_id[]"
                  :data="item.customers"
                  :class="{'customer_search':true}"
                  :serializer="customer => customer.label"
                  @hit="checkCustomer($event,index)"
                  placeholder="Type to search customer"
                  :ref="'cus_name_typeahead_'+index"
                  v-show="item.field =='cus_id'"
                />
                <vue-bootstrap-typeahead
                  @input="productlist($event,index)"
                  v-model="item.pdt_detail_id"
                  :id="'product_search_'+index"
                  name="pdt_detail_id[]"
                  :data="item.products"
                  :class="{'product_search':true}"
                  :serializer="product => product.label"
                  @hit="checkProduct($event,index)"
                  placeholder="Type to search product"
                  :ref="'pdt_name_typeahead_'+index"
                  v-show="item.field =='pdt_ids'"
                >
                  <template slot="suggestion" slot-scope="{ data, htmlText }">
                    <span>{{ data.label }}</span>&nbsp;
                    <br />
                    <small class="pr-3" v-if="data.pdt_legacy_id">{{data.pdt_legacy_id }}</small>
                    <small>{{ data.pdt_sku }}</small>
                  </template>
                </vue-bootstrap-typeahead>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="item.value"
                  v-if="item.field == 'inv_no' ||item.field=='order_no'|| item.field == 'ref_no' || item.field == 'grand_total' || item.field == 'buyer_gst_no' || item.field == 'due_amount' || item.field == ''"
                  v-validate="'required'"
                  :name="'value['+index+']'"
                />
                <DatePicker
                  @input="selectDate($event,index)"
                  :format="$AppDetails.organization.date_format"
                  v-validate="'required'"
                  v-model.trim="item.value"
                  v-if="item.field == 'created_date' || item.field == 'due_date'"
                  input-name="created_date"
                  lang="en"
                  input-class="form-control"
                  style="width:100% !important;"
                  :name="'value['+index+']'"
                >
                  <i class="fa fa-calendar text-dark" slot="calendar-icon" />
                </DatePicker>
                <b-form-select
                  v-if="item.field == 'sales_person_id' || item.field == 'inv_tags' || item.field == 'buyer_gst_type' || item.field == 'pjt_id' || item.field == 'inv_status'"
                  class="form-control"
                  v-model.trim="item.value"
                  v-validate="'required'"
                  :name="'value['+index+']'"
                >
                  <template v-if="item.field == 'sales_person_id'">
                    <option
                      :value="option.value"
                      v-for="option in sales_person_list"
                      :key="option.id"
                    >{{ option.label }}</option>
                  </template>
                  <template v-if="item.field == 'inv_tags'">
                    <option
                      :value="option.value"
                      v-for="option in tag_list"
                      :key="option.id"
                    >{{ option.label }}</option>
                  </template>
                  <template v-if="item.field == 'pjt_id'">
                    <option
                      :value="option.value"
                      v-for="option in pjt_list"
                      :key="option.id"
                    >{{ option.label }}</option>
                  </template>
                  <template v-if="item.field == 'inv_status'">
                    <option
                      :value="option.value"
                      v-for="option in inv_status_list"
                      :key="option.id"
                      v-if="option.value != '4'"
                    >{{ option.label }}</option>
                  </template>
                  <template v-if="item.field == 'buyer_gst_type'">
                    <option
                      :value="option.value"
                      v-for="option in gst_type_list"
                      :key="option.id"
                    >{{ option.label }}</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="1" lg="1" md="1" sm="1" xs="1">
              <b-form-group>
                <span>
                  <i class="glyphicon glyphicon-trash" @click="removeRow(index)"></i>
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="12" md="12" lg="12" sm="12" xs="12">
          <span
            class="text-link cursor_pointer fw-semi-bold"
            @click="addNewRow()"
            v-if="items.length<10"
          >+ Add more</span>
          <span v-else>
            <i class="fa fa-exclamation-triangle pl-2 text-warning fa-md"></i>
            Filter conditions must be within ten criteria
          </span>
        </b-col>
      </b-row>
      <!-- <div class="footer">
        <b-row>
          <b-col xl="12" lg="12" md="12" sm="12">
            <b-button variant="primary" @click="onRunReport" class="float-right ml-3">Run Report</b-button>
            <b-button variant="default" @click="closeModal('runreport')" class="float-right">Cancel</b-button>
          </b-col>
        </b-row>
      </div>-->
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="custom_index"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      ref="run"
    >
      <b-row>
        <b-col>
          <p class="fw-semi-bold pl-2">General</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='customer'||group.Group=='general'||group.Group=='pymnt_terms'||group.Group=='credit_limit'||group.Group=='sales_person'||group.Group=='project'||group.Group=='gst_type'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:30px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
        <b-col>
          <p class="fw-semi-bold pl-2">Invoice</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='invoice'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:25px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Invoice Details'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import DatePicker from "vue2-datepicker";
import { formatDate } from "@/mixins/formatDate";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";
function getPageSalesByInvoice(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchInvoiceLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: {
    DatePicker,
    VueBootstrapTypeahead,
    SaveFilterForm
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "InvoiceReport",
  mixins: [formatDate, scrollTable],
  data() {
    return {
      psort: this.sort,
      plabel: this.label,
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        Status: "inv_status_name",
        Date: "created_date",
        "Due Date": "due_date",
        Inv: "inv_no",
        "Order No": "order_no",
        " Ref#": "ref_no",
        " Customer": "cus_name",
        Total: "grand_total",
        Balance: "due_amount"
      },
      show_columns: [],
      reported_columns: [],
      items: [],
      show_columns_length: 0,
      available_columns: [
        {
          Group: "invoice",
          field: "ref_no",
          title: "Reference No",
          checked: false,
          colWidth: 140,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_fname",
          title: "First Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_lname",
          title: "Last Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_comp_name",
          title: "Company Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_legacy_id",
          title: "Customer ID",
          checked: false,
          colWidth: 150,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_ph_no_1",
          title: "Phone",
          checked: false,
          colWidth: 110,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_mail",
          title: "Mail",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "gst_type",
          field: "gst_type_name",
          title: "Gst Type",
          checked: false,
          colWidth: 210,
          align: ""
        },

        {
          Group: "customer",
          field: "cus_gst_no",
          title: "Gst No",
          checked: false,
          colWidth: 145,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_pan_no",
          title: "Pan No",
          checked: false,
          colWidth: 115,
          align: ""
        },
        {
          Group: "invoice",
          field: "place_of_supply",
          title: "Place of supply",
          checked: false,
          colWidth: 200,
          align: ""
        },
        {
          Group: "general",
          field: "cus_twitter_id",
          title: "Twitter id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_facebook_id",
          title: "Facebook id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_website",
          title: "Website",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_dept",
          title: "Designation",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_currency",
          title: "Currency",
          checked: false,
          colWidth: 180,
          align: ""
        },
        {
          Group: "pymnt_terms",
          field: "term_name",
          title: "Payment Term",
          checked: false,
          colWidth: 145,
          align: ""
        },
        {
          Group: "credit_limit",
          field: "credit_limit",
          title: "Credit Limit",
          checked: false,
          colWidth: 180,
          align: "right"
        },

        {
          Group: "sales_person",
          field: "sales_person_name",
          title: "Sales person Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "invoice",
          field: "export_grand_total",
          title: "Total(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "export_due_amount",
          title: "Balance(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "adjusted_amount",
          title: "Adjusted Amount (BCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "export_adjusted_amount",
          title: "Adjusted Amount (FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "inv_tax",
          title: "Tax (BCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },

        {
          Group: "invoice",
          field: "export_inv_tax",
          title: "Tax (FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "total_without_tax",
          title: "Total Without Tax (BCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "export_total_without_tax",
          title: "Total Without Tax (FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "paid_amount",
          title: "Paid Amount (BCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "export_paid_amount",
          title: "Paid Amount (FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "invoice",
          field: "inv_notes",
          title: "Notes",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "invoice",
          field: "internal_notes",
          title: "Description",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "project",
          field: "pjt_name",
          title: "Project Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        }
      ],
      columns: this.$route.query.show_columns,
      loader: false,
      group_by: 0,
      error_show: false,
      value: "",
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || "",
      saveforfuture: {},
      filterpage: "create",
      filteritems: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: ""
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async savefilterform() {
      this.saveforfuture = await {
        to_date: this.to_date,
        show_columns: this.show_columns,
        from_date: this.from_date,
        label: this.label,
        sort: this.sort,
        available_columns: this.available_columns,
        group_by: this.group_by,
        items: this.items
      };
      await this.$root.$emit("bv::show::modal", "savefilterform");
    },

    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchinvoiceexportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    selectDate(val, index) {
      this.items[index].value =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    displayvalue() {
      for (var i = 0; i <= this.items.length; i++) {
        this.$refs["cus_name_typeahead_" + i][0].inputValue = this.items[
          i
        ].cus_detail_id;

        this.$refs["pdt_name_typeahead_" + i][0].inputValue = this.items[
          i
        ].pdt_detail_id;
        //  mask and remover
        $("#customer_search_" + i + " input").css("pointer-events", "none");
        $("#customer_search_" + i + " input").css(
          "background-color",
          "#f7f7f7"
        );
        $("#customer_search_" + i + " input").css("position", "relative");
        $("#customer_search_" + i + " .input-group").append(
          "<span class='la la-close p-2' id='customer_remove_" + i + "'></span>"
        );
        $("#customer_remove_" + i).css("position", "absolute");
        $("#customer_remove_" + i).css("right", "0");

        //
        $("#product_search_" + i + " input").css("pointer-events", "none");
        $("#product_search_" + i + " input").css("background-color", "#f7f7f7");
        $("#product_search_" + i + " input").css("position", "relative");
        $("#product_search_" + i + " .input-group").append(
          "<span class='la la-close p-2' id='product_remove_" + i + "'></span>"
        );
        $("#product_remove_" + i).css("position", "absolute");
        $("#product_remove_" + i).css("right", "0");
      }
    },
    removecustomer(e, index) {
      if (e.target.matches("#customer_remove_" + index)) {
        $("#customer_search_" + index + " input").css("pointer-events", "all");
        $("#customer_search_" + index + " input").css(
          "background-color",
          "#fff"
        );
        $("#customer_search_" + index + " input").css("position", "");
        $("#customer_remove_" + index).remove();
        var cus_name = "cus_name_typeahead_" + index;
        this.$refs[cus_name][0].inputValue = "";
        this.items[index].value = "";
      }
      if (e.target.matches("#product_remove_" + index)) {
        $("#product_search_" + index + " input").css("pointer-events", "all");
        $("#product_search_" + index + " input").css(
          "background-color",
          "#fff"
        );
        $("#product_search_" + index + " input").css("position", "");
        $("#product_remove_" + index).remove();
        var pdt_name = "pdt_name_typeahead_" + index;
        this.$refs[pdt_name][0].inputValue = "";
        this.items[index].value = "";
      }
    },
    checkCustomer(event, index) {
      $("#customer_search_" + index + " input").css("pointer-events", "none");
      $("#customer_search_" + index + " input").css(
        "background-color",
        "#f7f7f7"
      );
      $("#customer_search_" + index + " input").css("position", "relative");
      $("#customer_search_" + index + " .input-group").append(
        "<span class='la la-close p-2' id='customer_remove_" +
          index +
          "'></span>"
      );
      $("#customer_remove_" + index).css("position", "absolute");
      $("#customer_remove_" + index).css("right", "0");
      this.items[index].value = event.value;
      var cus_name = "cus_name_typeahead_" + index;
      this.$refs[cus_name][0].inputValue = event.label;
      this.items[index].customers = [];
    },
    checkProduct(event, index) {
      $("#product_search_" + index + " input").css("pointer-events", "none");
      $("#product_search_" + index + " input").css(
        "background-color",
        "#f7f7f7"
      );
      $("#product_search_" + index + " input").css("position", "relative");
      $("#product_search_" + index + " .input-group").append(
        "<span class='la la-close p-2' id='product_remove_" +
          index +
          "'></span>"
      );
      $("#product_remove_" + index).css("position", "absolute");
      $("#product_remove_" + index).css("right", "0");
      this.items[index].value = event.value;

      var pdt_name = "pdt_name_typeahead_" + index;
      this.$refs[pdt_name][0].inputValue = event.label;

      this.items[index].products = [];
    },
    customerlist(event, index) {
      if (event != "") {
        store.dispatch("general/fetchCustomerData", event).then(() => {
          if (!this.items[index].value) {
            this.items[index].customers = this.customer_filter_list;
          }
        });
      }
    },
    productlist(event, index) {
      if (event != "") {
        store.dispatch("general/fetchProductData", event).then(() => {
          if (!this.items[index].value) {
            this.items[index].products = this.product_filter_list;
          }
        });
      }
    },
    getPresentValue(arr, prop, val) {
      var hasMatch = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },
    closeModal(id) {
      this.$refs[id].hide();
    },
    addNewRow() {
      this.items.push({
        customers: [],
        products: [],
        cus_detail_id: "",
        pdt_detail_id: "",
        filter_matching: "",
        field: "",
        comparator: "",
        value: ""
      });

      this.items[0].filter_matching = "When";
    },
    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.to_date = filter_content.to_date;
      this.from_date = filter_content.from_date;
      this.plabel = JSON.parse(JSON.stringify(filter_content.label));
      this.psort = JSON.parse(JSON.stringify(filter_content.sort));
      this.show_columns = filter_content.show_columns;
      this.group_by = filter_content.group_by;
      this.available_columns = filter_content.available_columns;
      this.items = filter_content.items;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    onRunReport(runreport) {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (runreport == 0 && this.$refs.daterangeupdate) {
            var child = this.$refs.daterangeupdate;
            child.checkConsole({
              startDate: this.from_date,
              endDate: this.to_date
            });
          }
          this.reported_columns = JSON.parse(
            JSON.stringify(this.available_columns)
          );
          this.show_columns_length = JSON.parse(
            JSON.stringify(this.show_columns)
          ).length;
          var group_by = this.group_by != 0 ? this.group_by : "";

          //To add export for selected columns
          for (var i = 0; i < this.reported_columns.length; i++) {
            if (this.reported_columns[i].checked == true) {
              this.export_xl[
                this.reported_columns[i].title
              ] = this.reported_columns[i].field;
            } else {
              delete this.export_xl[this.reported_columns[i].title];
            }
          }
          this.$router.push({
            name: this.$route.name,
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              label: $.isEmptyObject(this.selectedfilter)
                ? this.label
                : this.plabel,
              sort: $.isEmptyObject(this.selectedfilter)
                ? this.sort
                : this.psort,
              select_columns: JSON.stringify({
                columns: JSON.stringify(this.show_columns)
              }),
              custom: JSON.stringify({
                columns: JSON.stringify(this.items)
              }),
              group_by
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    },
    removeRow(index) {
      var i;
      if (typeof this.items[parseInt(index) + 1] != "undefined") {
        for (i = index; i < this.items.length - 1; i++) {
          var cus_name = "cus_name_typeahead_" + i;
          var pdt_name = "pdt_name_typeahead_" + i;
          this.$refs[cus_name][0].inputValue = this.items[i + 1].cus_detail_id;
          this.$refs[pdt_name][0].inputValue = this.items[i + 1].pdt_detail_id;
        }
      }
      this.items.splice(index, 1);
      if (typeof this.items[parseInt(index)] != "undefined") {
        this.items[0].filter_matching = "When";
      }
    }
  },
  mounted: function() {
    var index;
    for (index = 0; index < this.items.length; index++) {
      var cus_name = "cus_name_typeahead_" + index;
      var pdt_name = "pdt_name_typeahead_" + index;
      if (
        typeof this.$refs[cus_name] != "undefined" &&
        this.items[index].field == "cus_id"
      ) {
        $("#customer_search_" + index + " input").css("pointer-events", "none");
        $("#customer_search_" + index + " input").css(
          "background-color",
          "#f7f7f7"
        );
        $("#customer_search_" + index + " input").css("position", "relative");
        $("#customer_search_" + index + " .input-group").append(
          "<span class='la la-close p-2' id='customer_remove_" +
            index +
            "'></span>"
        );
        $("#customer_remove_" + index).css("position", "absolute");
        $("#customer_remove_" + index).css("right", "0");
        this.$refs[cus_name][0].inputValue = this.items[index].cus_detail_id;
      }
      if (
        typeof this.$refs[pdt_name] != "undefined" &&
        this.items[index].field == "pdt_ids"
      ) {
        $("#product_search_" + index + " input").css("pointer-events", "none");
        $("#product_search_" + index + " input").css(
          "background-color",
          "#f7f7f7"
        );
        $("#product_search_" + index + " input").css("position", "relative");
        $("#product_search_" + index + " .input-group").append(
          "<span class='la la-close p-2' id='product_remove_" +
            index +
            "'></span>"
        );
        $("#product_remove_" + index).css("position", "absolute");
        $("#product_remove_" + index).css("right", "0");
        this.$refs[pdt_name][0].inputValue = this.items[index].pdt_detail_id;
      }
    }
  },
  created() {
    // this.from_date = this.$route.query.from_date;
    // this.to_date = this.$route.query.to_date;
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          select_columns: JSON.stringify({
            columns: JSON.stringify(this.show_columns)
          }),
          custom: JSON.stringify({
            columns: JSON.stringify(this.items)
          })
        }
      });
    }
    if (
      typeof this.$route.query.custom != "undefined" &&
      this.$route.query.custom != null
    ) {
      this.from_date = this.$route.query.from_date;
      this.to_date = this.$route.query.to_date;
      this.group_by = this.$route.query.group_by;
      this.items =
        Object.entries(JSON.parse(this.$route.query.custom)).length === 0 &&
        JSON.parse(this.$route.query.custom).constructor === Object
          ? []
          : JSON.parse(JSON.parse(this.$route.query.custom)["columns"]);
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch(
      "sales/fetchSalesDetails",
      JSON.stringify({
        type: "invoice"
      })
    );
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageSalesByInvoice(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    typeof this.$refs.run != "undefined" ? this.$refs.run.hide() : "";
    getPageSalesByInvoice(routeTo, next);
  },
  computed: {
    ...mapState({
      customer_filter_list: state => state.general.customer_filter_list,
      product_filter_list: state => state.general.product_filter_list,
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      group_total_amount: state => state.reports.group_total_amount,
      tag_list: state => state.sales.tag_list,
      sales_person_list: state => state.sales.sales_person_list,
      pjt_list: state => state.sales.pjt_list,
      inv_status_list: state => state.sales.inv_status_list,
      gst_type_list: state => state.sales.gst_type_list,
      export: state => state.reports.export,
      reportsfilter: state => state.general.reportsfilter
    }),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    },
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"])
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
</style>